<script>
import { required } from "vuelidate/lib/validators";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import moment from "moment";
import StrKontrolGirisKanit from "../../StrKurumsalPerformans/StrKontrolGirisKanit/AddEdit.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import store from "@/state/store";
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Soru Formu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    formtextarea,
    formcombobox,
    AddEdit,
    StrKontrolGirisKanit,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("StrKontrolGiris.Title"),
      items: [
        {
          text: this.$t("StrKontrolGiris.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrKontrolGiris.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrKontrolGiris.Title"),
          active: true,
        },
      ],
      KullaniciBilgileri: null,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: {},
      Kontrolgirisid: "",
      DefaultPage: 1,
      TableData: {},
      TableDataGroup: {},
      ComboBoxBirimId: [],
      ComboBoxDonemId: [],
      ComboBoxAltDonemId: [],
      ComboBoxTanimId: [],
      Raporgirisid: "",
      secilen_birim: null,
      Tarih: moment(new Date()).format('YYYY-MM-DD') ,
      Filter: {
        BirimId: null,
        DonemId: "",
        AltDonemId: "",
        TanimId: "",
      },
      FormDataType: {
        Aciklama: {
          FieldName: "Aciklama",
          Field: "input",
          FieldTitle: this.$t("StrKontrolGiris.AddEdit.FormTitleEdit"),
          Disabled: false
        },
      },
      SorguKontrol: false,
      OnayDurumu: false,

    };
  },
  watch:{
    OnayDurumu(){
    //  this.FormDataType.Aciklama.Disabled = this.OnayDurumu
    },

  },
  validations: {
    FormData: {
      Aciklama: {  },
    },
    Filter: {
      BirimId: { required },
      DonemId: { required },
      AltDonemId: {},
      TanimId: {},
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid.FormData) {
        this.Update("StrKontrolGiris", this.FormData).then((res) => {
          if (res) {
            this.$emit("Update", this.FormData);
            this.$bvModal.hide("StrKontrolGiris");
          }
        });
      }
    },
    Get() {
      this.KullaniciBilgileri = store.getters["auth/UserRolles"]
    },
    FilterGet() {
      this.$v.$touch();
      if (!this.$v.Filter.$invalid) {
        this.SorguKontrol = true
        let Filter = "&BirimId=" + this.Filter.BirimId + "&DonemId=" + this.Filter.DonemId + "&TanimId=" + this.Filter.TanimId;

        this.ActionsFilterGet({ Service: "StrKontrolGiris/GetSoruFormu", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
      //    this.OnayDurumu = this.OnayKontrolAll()
        });
      }
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    DonemSec() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ComboBoxAltDonemId = [];
          let Tip=[];
      if (this.Filter.DonemId) {
        let Tarih = moment(new Date()).format("YYYY-MM-DD");
        this.ActionsFilterGet({ Service: "okeyvalues", Page: this.Page, Filter: "&Tip=1561" }).then((resp) => {
                  for(var i=0; i<resp.Data.length; i++)
          {
              if(resp.Data[i].Kod==3 || resp.Data[i].Kod==4 ) {

                  Tip.push(resp.Data[i].Id);

              }

          }
          let altsorgu="&UstIdDoluMu=true&Approval=true";

          let tipler="";

          for (var s=0; s<Tip.length; s++){

              tipler=tipler+"&TipId="+Tip[s];

          }

          altsorgu=altsorgu+tipler;

          let Filter = "&UstId=" + this.Filter.DonemId + altsorgu;
          this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: Filter }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
              if (this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= Tarih && Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)) {
                if (res.Data[i].Approval) {
                  this.ComboBoxAltDonemId.push({
                    Id: res.Data[i].Id,
                    Value: res.Data[i].Aciklama,
                  });
                }
              }
            }
          });
        });
      }
    },

    OnayHazir(EylemDetay, DonemId) {
      let VeriUzunlugu = EylemDetay.length;
      let durum = true;
      for (var i = 0; i < VeriUzunlugu; i++) {
        for (var j = 0; j < EylemDetay[i].Giris.length; j++) {
          if (EylemDetay[i].Giris[j].DonemId == DonemId) {
            if (EylemDetay[i].Giris[j].Deger == null) {
              durum = false;
            }
          }
        }
      }
      return durum;
    },
    OnayKontrol(EylemDetay, DonemId) {
      let VeriUzunlugu = EylemDetay.length;
      let durum = true;
      for (var i = 0; i < VeriUzunlugu; i++) {
        for (var j = 0; j < EylemDetay[i].Giris.length; j++) {
          if (EylemDetay[i].Giris[j].DonemId == DonemId) {
            if (EylemDetay[i].Giris[j].Onay == null || EylemDetay[i].Giris[j].Onay == 0) {
              durum = false;
            }
          }
        }
      }
      return durum;
    },
    StrKontrolGirisOnay(EylemDetay, DonemId, Islem) {
      let Onay = 1;
      if (Islem != "Onayla") {
        Onay = 0;
      }
      let VeriUzunlugu = EylemDetay.length;
      for (var i = 0; i < VeriUzunlugu; i++) {
        for (var j = 0; j < EylemDetay[i].Giris.length; j++) {
          if (EylemDetay[i].Giris[j].DonemId == DonemId) {
            let FormData = {
              Id: EylemDetay[i].Giris[j].Id,
              Onay: Onay,
              DonemId: EylemDetay[i].Giris[j].DonemId,
              BirimId: EylemDetay[i].Giris[j].BirimId,
              TanimId: EylemDetay[i].Giris[j].TanimId,
            };
            this.Update("StrKontrolGiris", FormData);
            this.FilterGet();
          }
        }
      }
    },



    OnayKontrolAll(Donemid) {

let durum = true;
for (var a = 0; a < Object.keys(this.TableData).length; a++) {
  for (var i = 0; i < this.TableData[a].EylemDetay.length; i++) {
    for (var j = 0; j < this.TableData[a].EylemDetay[i].Giris.length; j++) {
      if(this.TableData[a].EylemDetay[i].Giris[j].DonemId == Donemid){
        if (this.TableData[a].EylemDetay[i].Giris[j].Onay == null ||
            this.TableData[a].EylemDetay[i].Giris[j].Onay == 0) {
          durum = false;
        }
      }


    }
  }
}
return durum;

},
    StrKontrolGirisOnayAll(Islem,Donemid) {
      let Onay = 1;
      if (Islem != "Onayla") {
        Onay = 0;
      }

      if(this.OnayHazirAllDetay(Donemid).length > 0){
        var error = this.OnayHazirAllDetay(Donemid);
        var message = 'Onay İçin Hazır Değil! \n Aşağıdaki Eylemleri Kontrol Ediniz.';
        for(var s =0; s<error.length; s++){
          message += ' \n* '+error[s]
        }
        this.$toast.error(message);
      }
      else{
            var durum = true
                    for (var a = 0; a < Object.keys(this.TableData).length; a++) {
                      for (var i = 0; i < this.TableData[a].EylemDetay.length; i++) {
                        for (var j = 0; j < this.TableData[a].EylemDetay[i].Giris.length; j++) {
                          if(this.TableData[a].EylemDetay[i].Giris[j].DonemId == Donemid){
                                let FormData = {
                                  Id: this.TableData[a].EylemDetay[i].Giris[j].Id,
                                  Onay: Onay,
                                  DonemId: this.TableData[a].EylemDetay[i].Giris[j].DonemId,
                                  BirimId: this.TableData[a].EylemDetay[i].Giris[j].BirimId,
                                  TanimId: this.TableData[a].EylemDetay[i].Giris[j].TanimId,
                                  Deger: this.TableData[a].EylemDetay[i].Giris[j].Deger,
                                  Aciklama: this.TableData[a].EylemDetay[i].Giris[j].Aciklama,
                                };
                                this.Update("StrKontrolGiris", FormData, false).then((res) => {
                                  if(!res){
                                    durum = false
                                  }

                                });
                              }

                        }
                      }
                    }
                    if(durum){
                                if (Islem != "Onayla") {
                                  this.$toast.success("Onay Kaldırma İşlemi Başarılı");
                                }
                                else{
                                  this.$toast.success("Onaylama İşlemi Başarılı");
                                }
                    }
            this.FilterGet();
      }
    },

    OnayHazirAllDetay(Donemid) {
      let durum = [];
      for (var a = 0; a < Object.keys(this.TableData).length; a++) {
        for (var i = 0; i < this.TableData[a].EylemDetay.length; i++) {
          for (var j = 0; j < this.TableData[a].EylemDetay[i].Giris.length; j++) {
            if(this.TableData[a].EylemDetay[i].Giris[j].DonemId == Donemid){
                  if (this.TableData[a].EylemDetay[i].Giris[j].Deger == null) {
                    durum.push("'"+this.TableData[a].EylemDetay[i].Eylem.Eylem+"' Giriş Yapılmadı." );
                  }
                  if(this.TableData[a].EylemDetay[i].Giris[j].Deger == 2
                  && this.TableData[a].EylemDetay[i].Giris[j].Kanitsayisi == 0 ){
                    durum.push("'"+this.TableData[a].EylemDetay[i].Eylem.Eylem+"' Kanıt Eksik." );
                  }
            }
          }
        }
      }
      return durum;
    },
    OnayHazirAll(Donemid) {
      let durum = true;
      for (var a = 0; a < Object.keys(this.TableData).length; a++) {
        for (var i = 0; i < this.TableData[a].EylemDetay.length; i++) {
          for (var j = 0; j < this.TableData[a].EylemDetay[i].Giris.length; j++) {
            if (this.TableData[a].EylemDetay[i].Giris[j].DonemId == Donemid) {
                if (this.TableData[a].EylemDetay[i].Giris[j].Deger == null) {
                  durum = false;
                }
                if(this.TableData[a].EylemDetay[i].Giris[j].Deger == 2 &&
                this.TableData[a].EylemDetay[i].Giris[j].Kanitsayisi == 0 && Donemid != '0ef943fb-8b48-4550-9255-4927b178ce36'){
                  durum = false;

                }
              }
          }
        }
      }
      return durum;
    },
    DonemKontrol(Donemid){
      let Donem = false;
      for(var Data in this.ComboBoxAltDonemId){
        if(this.ComboBoxAltDonemId[Data].Id == Donemid){
          Donem = true;
        }
      }
    return Donem
    },
    Secilmis_Idler(secilmis) {
      if (secilmis != null) {

          this.secilen_birim = secilmis;
          this.Filter.BirimId = this.secilen_birim;
          if(this.secilen_birim==this.universite_id){
            this.universite=1;
          } else{ this.universite=0;}
      }
    },

  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };


    let sorgu = "&Tip=1561";
    let Tip=[];

      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
        console.log(res)
          for(var i=0; i<res.Data.length; i++)
          {
              if(res.Data[i].Kod==3 || res.Data[i].Kod==4 ) {

                  Tip.push(res.Data[i].Id);

              }

          }

          let altsorgu="&UstIdDoluMu=false&Approval=true";

          let tipler="";

          for (var s=0; s<Tip.length; s++){

              tipler=tipler+"&TipId="+Tip[s];

          }

          altsorgu=altsorgu+tipler;



          this.ActionsFilterGet({"Service":"StrPerfDonem", "Page":Page,Filter:altsorgu}).then((res) => {
            let Tarih= moment(new Date()).format('YYYY-MM-DD');
            for (var i = 0; i < res.Data.length; i++) {
              if(this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= Tarih && Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)){

                  this.ComboBoxDonemId.push({
                  Id: res.Data[i].Id,
                  Value: res.Data[i].Aciklama,
                });

              }
            }
          });
        });

    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxBirimId.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    });
    this.ActionsGet({ Service: "StrKontrolTanim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxTanimId.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].TamamlanmaAciklama,
        });
      }
    });
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-sm-6">
              <div class="row ">
                <div class="col-md-12">
                  <BirimSecimi
                    :title="'Birim'"
                    :title_class="'mb-2'"
                    :closeOnSelect="true"
                    :sutun="'0'"
                    :multiple="false"
                    :YetkiKontrol="1"
                    :BirimTipId="null"
                    @Secilmis_Idler="Secilmis_Idler($event)"
                  />
                  <div
                    v-if="$v.Filter.BirimId.$error"
                    class="invalid-feedback d-block"
                  >
                    <span v-if="$v.Filter.BirimId.required == false">{{
                      $t("ValidationMessage.required")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col-md-12 ">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'DonemId',
                      Field: 'combobox',
                      FieldTitle: $t('StrKontrolGiris.Filtreleme.DonemId'),
                      ComboDataArray: ComboBoxDonemId,
                    }"
                    :Value="Filter.DonemId"
                    :v="$v.Filter.DonemId"
                    @input="(Filter.DonemId = $event), DonemSec()"
                  />
                </div>

                <div class="row ">
                  <div class="col-md-12" style="padding-right: 0px;">
                    <b-button
                      @click="FilterGet"
                      class="btn btn-primary w-100"
                      variant="primary"
                      >{{ $t("StrKontrolGiris.Filtreleme.Button") }}</b-button
                    >
                  </div>
                </div>
                <div class="col-md-5 mb-3" v-if="0">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'AltDonemId',
                      Field: 'combobox',
                      FieldTitle: $t('StrKontrolGiris.Filtreleme.AltDonemId'),
                      ComboDataArray: ComboBoxAltDonemId,
                    }"
                    :Value="Filter.AltDonemId"
                    :v="$v.Filter.AltDonemId"
                    @input="Filter.AltDonemId = $event"
                  />
                </div>
                <div class="col-md-5 mb-3" v-if="0">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'TanimId',
                      Field: 'combobox',
                      FieldTitle: $t('StrKontrolGiris.Filtreleme.TanimId'),
                      ComboDataArray: ComboBoxTanimId,
                    }"
                    :Value="Filter.TanimId"
                    :v="$v.Filter.TanimId"
                    @input="Filter.TanimId = $event"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="Object.keys(TableData).length > 0">
        <div class="card">
          <div class="card-body">
            <div
              class="table-responsive"
              v-for="(TableDataVerileri, index) in TableData"
              :key="index"
            >
              <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th scope="col">{{ TableDataVerileri.AnaGrupValue }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <table class="table table-striped table-bordered mb-0">
                      <thead>
                        <tr>
 <th scope="col">
  {{ TableDataVerileri.StandartKodNo }} <br/>
  <small class="text-muted">  {{ TableDataVerileri.Aciklama }}</small>
</th>
                          <th
                            scope="col"
                            v-for="(GirisVerileri, index2) in TableDataVerileri
                              .EylemDetay[0].Giris"
                            :key="index2"
                          >
                            <div
                              class="d-flex flex-column justify-content-center align-items-center"
                            >
                              {{ GirisVerileri.DonemAdi }} <br />
                              <div v-if="index == 0">
                                <button
                                  @click="
                                    StrKontrolGirisOnayAll(
                                      'Onayla',
                                      GirisVerileri.DonemId
                                    )
                                  "
                                  v-if="
                                    OnayKontrolAll(GirisVerileri.DonemId) ==
                                      false &&
                                      RolesControl(
                                        KullaniciBilgileri,
                                        'StrIckontrolSoruOnay'
                                      ) &&
                                      DonemKontrol(GirisVerileri.DonemId)
                                  "
                                  type="button"
                                  class="btn btn-success mb-2  w-100"
                                >
                                  <i class="mdi mdi-check-all me-1"></i
                                  >{{ $t("StrKontrolGiris.Table.Onayla") }}
                                </button>
                                <button
                                  @click="
                                    StrKontrolGirisOnayAll(
                                      'OnayIptal',
                                      GirisVerileri.DonemId
                                    )
                                  "
                                  v-else-if="
                                    DonemKontrol(GirisVerileri.DonemId) &&
                                      OnayKontrolAll(GirisVerileri.DonemId) &&
                                      OnayHazirAll(GirisVerileri.DonemId) &&
                                      RolesControl(
                                        KullaniciBilgileri,
                                        'StrIckontrolSoruOnayIptal'
                                      )
                                  "
                                  type="button"
                                  class="btn btn-danger  mb-2 w-100"
                                >
                                  <i class="mdi mdi-close me-1"></i
                                  >{{ $t("StrKontrolGiris.Table.OnayIptal") }}
                                </button>

                                <span
                                  v-else-if="
                                    OnayKontrolAll(GirisVerileri.DonemId) &&
                                      OnayHazirAll(GirisVerileri.DonemId) &&
                                      !RolesControl(
                                        KullaniciBilgileri,
                                        'StrIckontrolSoruOnayIptal'
                                      )
                                  "
                                  class="btn btn-danger  mb-2 w-100"
                                  >Onaylı</span
                                >
                                <span
                                  v-else-if="
                                    OnayKontrolAll(GirisVerileri.DonemId) ==
                                      false &&
                                      RolesControl(
                                        KullaniciBilgileri,
                                        'StrIckontrolSoruOnay'
                                      ) == false
                                  "
                                  class="btn btn-success mb-2  w-100"
                                  >Onaylanmadı</span
                                >
                              </div>
                              <div v-if="0">
                                <button
                                  @click="
                                    StrKontrolGirisOnay(
                                      TableDataVerileri.EylemDetay,
                                      GirisVerileri.DonemId,
                                      'Onayla'
                                    )
                                  "
                                  v-if="
                                    OnayKontrol(
                                      TableDataVerileri.EylemDetay,
                                      GirisVerileri.DonemId
                                    ) == false &&
                                      OnayHazir(
                                        TableDataVerileri.EylemDetay,
                                        GirisVerileri.DonemId
                                      ) &&
                                      RolesControl(
                                        KullaniciBilgileri,
                                        'StrIckontrolSoruOnay'
                                      )
                                  "
                                  type="button"
                                  class="btn btn-success m-2 "
                                >
                                  <i class="mdi mdi-check-all me-1"></i
                                  >{{ $t("StrKontrolGiris.Table.Onayla") }}
                                </button>
                                <button
                                  @click="
                                    StrKontrolGirisOnay(
                                      TableDataVerileri.EylemDetay,
                                      GirisVerileri.DonemId,
                                      'OnayIptal'
                                    )
                                  "
                                  v-else-if="
                                    OnayKontrol(
                                      TableDataVerileri.EylemDetay,
                                      GirisVerileri.DonemId
                                    ) &&
                                      OnayHazir(
                                        TableDataVerileri.EylemDetay,
                                        GirisVerileri.DonemId
                                      ) &&
                                      RolesControl(
                                        KullaniciBilgileri,
                                        'StrIckontrolSoruOnayIptal'
                                      )
                                  "
                                  type="button"
                                  class="btn btn-danger m-2"
                                >
                                  <i class="mdi mdi-close me-1"></i
                                  >{{ $t("StrKontrolGiris.Table.OnayIptal") }}
                                </button>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(AltTableDataVerileri,
                          index) in TableDataVerileri.EylemDetay"
                          :key="index"
                        >
                          <th scope="row">
                            {{ AltTableDataVerileri.Eylem.Kod }}
                            {{ AltTableDataVerileri.Eylem.Eylem }}
                          </th>

                          <AddEdit
                            v-for="(GirisVerileri,
                            index) in AltTableDataVerileri.Giris"
                            :key="index"
                            :GirisVerileri="GirisVerileri"
                            :Filter="Filter"
                            @Data="FormData = $event"
                            @Kontrolgirisid="Kontrolgirisid = $event"
                            @Raporgirisid="Raporgirisid = $event"
                            :OnayDurumu="
                              GirisVerileri.Onay == '1' ? true : false
                            "
                            @OnayDurumu="OnayDurumu = $event"
                          />
                        </tr>
                      </tbody>
                    </table>
                  </tr>
                </tbody>
              </table>
              <br /><br />
            </div>
          </div>
        </div>
      </div>

      <b-alert
        show
        variant="danger"
        v-if="Object.keys(TableData).length == 0 && SorguKontrol"
      >
        Kayıt Bulunamadı
      </b-alert>

      <b-modal
        id="StrKontrolGiris"
        size="lg"
        :title="$t('StrKontrolGiris.AddEdit.FormTitleEdit')"
        title-class="font-18"
        hide-footer
      >
        <Form @submit.prevent="onSubmit">
          <formtextarea
            :FormDataType="FormDataType.Aciklama"
            :Value="FormData.Aciklama"
            :v="$v.FormData.Aciklama"
            @input="FormData.Aciklama = $event"
          />
          <button
            class="btn btn-primary"
            type="submit"
            v-if="FormData.Onay == '1' ? false : true"
          >
            {{ $t("StrKontrolGiris.AddEdit.Button") }}
          </button>
        </Form>
      </b-modal>

      <StrKontrolGirisKanit
        :Kontrolgirisid="Kontrolgirisid"
        @TableUpdate="FilterGet()"
        :Raporgirisid="Raporgirisid"
        :OnayDurumu="OnayDurumu"
      />
    </Layout>
  </Loader>
</template>
